// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbeddedJavaScriptBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * EmbeddedJavascript Component
 */
!(function() {
  var React = require('react');
  var EventsUtils = require('EventUtils');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidatableTextArea = Validator()(require('share/components/controls/Izenda.TextArea'));
  var constants = require('logic/data/Izenda.PropertiesBuilderConstants').EMBEDDED_JAVASCRIPT;
  var subReportConstant = require('logic/data/Izenda.PropertiesBuilderConstants').SUB_REPORT;
  var messages = require('logic/data/Izenda.PropertiesBuilderConstants').MESSAGE;
  var ViewSetting = require('./Izenda.ViewSetting');
  var localizer = require('share/localization/Izenda.Localizer');
  var { isNil, find } = require('lodash/fp');

  var EmbeddedJavascriptPopup = React.createClass({
    getDefaultProps: function() {
      return {
        value: {
          script: ''
        }
      };
    },

    getInitialState: function() {
      var value = this.props.value;
      var selectedIcon = value.selectedIconValue;
      if (!selectedIcon || isNil(selectedIcon.icon) || isNil(selectedIcon.value)) {
        selectedIcon = {
          icon: subReportConstant.DEFAULT_ICON.icon,
          value: subReportConstant.DEFAULT_ICON.value
        };
      }

      return {
        script: this.props.value.script,
        viewSettingByLink: isNil(value.viewSettingByLink)
          ? true // Default value
          : value.viewSettingByLink,
        selectedIconValue: selectedIcon
      };
    },

    beforeClosing: function(valManager, type) {
      var props = this.props;

      if (type === 'accept' && props.checkUniqLinkOption && !props.checkUniqLinkOption(this.state, constants.NAME)) {
        return props.confirmMessage('error', messages.DUPLICATE_VIEW_SETTING);
      } else {
        return Promise.resolve(true);
      }
    },

    getValue: function() {
      return this.state;
    },

    updateViewSettingByLink: function() {
      this.setState({
        viewSettingByLink: !this.state.viewSettingByLink
      });
    },

    updateSelectedViewSettingIcon: function(value) {
      var selectedIcon = find({ value: value }, subReportConstant.ICON_TYPES);
      if (selectedIcon) {
        this.setState({
          selectedIconValue: {
            icon: selectedIcon.icon,
            value: selectedIcon.value
          }
        });
      }
    },

    renderViewSetting: function() {
      var state = this.state;

      return (
        this.props.hiddenIconSettingSubReport === false && (
          <ViewSetting
            viewSettingByLink={state.viewSettingByLink}
            selectedIconValue={state.selectedIconValue}
            updateSelectedViewSettingIcon={this.updateSelectedViewSettingIcon}
            updateViewSettingByLink={this.updateViewSettingByLink}
          />
        )
      );
    },

    renderBody: function() {
      var notifyChange = EventsUtils.notifyChange;
      var handleChangeScript = function(value) {
        this.setState({
          script: value
        });
      }.bind(this);

      return (
        <div className="embedded-script">
          <label>{constants.CONTENT_DESCRIPTION}</label>
          <ValidatableTextArea
            className="form-control"
            rows="5"
            placeholder={localizer.getText('REPORTDESIGNER_PLACEHOLDER_PASTE_JAVASCRIPT_CODE')}
            onChange={notifyChange(handleChangeScript, EventsUtils.INPUT)}
            value={this.state.script}
            validations={constants.CONSTRAINTS.SCRIPT}
            field="script"
          />
        </div>
      );
    },

    render: function() {
      return (
        <Popup.Body>
          {this.renderBody()}
          {this.renderViewSetting()}
        </Popup.Body>
      );
    }
  });

  module.exports = EmbeddedJavascriptPopup;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.EmbeddedJavascriptBody.jsx